const Links = [
  {
    name: "Home",
    link: "/home",
  },
  // {
  //   name: "Services",
  //   link: "/services",
  // },
  // {
  //   name: "Gallery",
  //   isMenu: true,
  //   menuItems: [
  //     {
  //       name: "Hair",
  //       link: "/gallery#hair",
  //     },
  //     {
  //       name: "Reels",
  //       link: "/gallery#reels",
  //     }
  //   ]
  // },
  {
    name: "Pricing",
    link: "/services",
  },
  {
    name: "Gallery",
    link: "/gallery#hair",
  },
  {
    name: "Testimonials",
    link: "/reviews",
  },
  // {
  //   name: "Styled Shoots",
  //   link: "/photoshoot",
  // },
  {
    name: "T&Cs",
    link: "/faq",
  },
  {
    name: "Enquire",
    link: "/email",
  }
];

export default Links;